import React from 'react';
import { motion } from 'framer-motion';

const RestoranVideo = ({ language = 'de' }) => {
  
  const translations = {
    de: {
      videoTitle: 'Erleben Sie Ristorante La Casa'
    },
    en: {
      videoTitle: 'Experience Ristorante La Casa'
    }
  };

  const t = translations[language];

  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-luxury-charcoal via-black/95 to-luxury-charcoal relative overflow-x-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-5">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-luxury-gold rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`
            }}
          />
        ))}
      </div>

      <div className="container-custom relative z-10">
        {/* Title */}
        <div
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display font-black text-white mb-4">
            {t.videoTitle}
          </h2>
          <div className="flex items-center justify-center gap-3 mt-8">
            <div className="h-0.5 w-16 bg-gradient-to-r from-transparent to-luxury-gold" />
            <div className="w-2 h-2 bg-luxury-gold rounded-full" />
            <div className="h-0.5 w-32 bg-luxury-gold" />
            <div className="w-2 h-2 bg-luxury-gold rounded-full" />
            <div className="h-0.5 w-16 bg-gradient-to-l from-transparent to-luxury-gold" />
          </div>
        </div>

        {/* Restaurant Video */}
        <div
          className="max-w-6xl mx-auto px-4"
        >
          <div className="relative rounded-3xl overflow-hidden shadow-[0_0_80px_rgba(212,175,55,0.3)] border-2 border-luxury-gold/30 max-w-full">
            {/* Decorative corners */}
            <div className="absolute top-0 left-0 w-20 h-20 border-t-4 border-l-4 border-luxury-gold z-10 rounded-tl-3xl" />
            <div className="absolute top-0 right-0 w-20 h-20 border-t-4 border-r-4 border-luxury-gold z-10 rounded-tr-3xl" />
            <div className="absolute bottom-0 left-0 w-20 h-20 border-b-4 border-l-4 border-luxury-gold z-10 rounded-bl-3xl" />
            <div className="absolute bottom-0 right-0 w-20 h-20 border-b-4 border-r-4 border-luxury-gold z-10 rounded-br-3xl" />
            
            <video
              className="w-full h-auto"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source
                src="https://firebasestorage.googleapis.com/v0/b/autohausmiftari-b0e2f.firebasestorage.app/o/video_hotel.webm?alt=media&token=ab12ce4e-ca8e-43ac-a21a-b3aaae3da862"
                type="video/webm"
              />
              {language === 'de' 
                ? 'Ihr Browser unterstützt das Video-Tag nicht.' 
                : 'Your browser does not support the video tag.'}
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RestoranVideo;
